import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon } from 'lucide-react';
const bonuses = [{
  title: 'Guía de Suplementos Latam',
  desc: 'Lo que sí funciona en tu farmacia local.',
  value: '$47'
}, {
  title: "Protocolo 'Libido de Acero'",
  desc: 'Recupera tu potencia sin fármacos.',
  value: '$67'
}, {
  title: 'Cheat-Sheet del Restaurante',
  desc: 'Disfruta la vida social sin engordar.',
  value: '$47'
}, {
  title: 'Hacks de Sueño Profundo',
  desc: 'Despierta con el tanque lleno.',
  value: '$47'
}, {
  title: 'Recetario Alfa (10 Minutos)',
  desc: 'Comida potente sin perder tiempo.',
  value: '$37'
}];
export function OfferSection() {
  return <section className="py-24 px-4 bg-[#0a0e1a]" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <FadeIn data-id="element-118">
          <div className="text-center mb-16" data-id="element-119">
            <h2 className="text-3xl md:text-5xl font-bold text-[#f5f5f5] mb-6" data-id="element-120">
              El Sistema Completo para{' '}
              <span className="text-[#c9a84c]" data-id="element-121">Devolverte tu Vitalidad</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid lg:grid-cols-12 gap-8 items-start" data-id="element-122">
          <FadeIn delay={0.1} className="lg:col-span-5" data-id="element-123">
            <div className="sticky top-24" data-id="element-124">
              <img src="https://cdn.magicpatterns.com/uploads/mKrxWce1FESZFt9hJ19F2j/heylloyd-image-1772818255775.png" alt="Código Alfa 40+ Bundle" className="w-full h-auto rounded-2xl shadow-[0_0_40px_rgba(201,168,76,0.15)] border border-[#c9a84c]/20" data-id="element-125" />
            </div>
          </FadeIn>

          <div className="lg:col-span-7 space-y-4" data-id="element-126">
            <FadeIn delay={0.2} data-id="element-127">
              <div className="bg-gradient-to-r from-[#111827] to-[#0a0e1a] border border-[#c9a84c] p-6 rounded-xl flex gap-4 items-start shadow-[0_0_20px_rgba(201,168,76,0.1)]" data-id="element-128">
                <BookOpenIcon className="w-8 h-8 text-[#c9a84c] shrink-0 mt-1" data-id="element-129" />
                <div className="flex-grow" data-id="element-130">
                  <div className="flex flex-wrap justify-between items-baseline gap-2 mb-2" data-id="element-131">
                    <h3 className="text-xl font-bold text-[#f5f5f5]" data-id="element-132">
                      Ebook Principal: Código Alfa 40+
                    </h3>
                    <span className="text-[#9ca3af] line-through text-sm" data-id="element-133">
                      Valor: $25.50
                    </span>
                  </div>
                  <p className="text-[#9ca3af]" data-id="element-134">
                    El mapa exacto de 28 días para tu reajuste hormonal.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}